<template>
  <el-tabs
      :value="activeTabMap || 'adCampaign'"
      @tab-click="tabClick"
      class="ad-tabs">
    <el-tab-pane name="adCampaign" lazy>
      <template #label>广告活动</template>
      <app-sd-ad-campaign
          :market-id="marketId"
          table-name="sdAdCampaign"
      ></app-sd-ad-campaign>
    </el-tab-pane>
    <el-tab-pane name="adGroup" lazy>
      <template #label>广告组</template>
      <app-sd-ad-group
          :market-id="marketId"
          table-name="sdAdGroup"
      ></app-sd-ad-group>
    </el-tab-pane>
    <el-tab-pane name="adProduct" lazy>
      <template #label>广告</template>
      <app-sd-ad-product
          :market-id="marketId"
          table-name="sdAdProduct"
      ></app-sd-ad-product>
    </el-tab-pane>
    <el-tab-pane name="adProductTarget" lazy>
      <template #label>商品投放</template>
      <app-sd-ad-product-target
          :market-id="marketId"
          table-name="sdAdProductTarget"
      ></app-sd-ad-product-target>
    </el-tab-pane>
    <el-tab-pane name="adNegTarget" lazy>
      <template #label>否定商品投放</template>
      <app-sd-ad-neg-target
          :market-id="marketId"
          table-name="sdAdNegTarget"
      ></app-sd-ad-neg-target>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import AppSdAdCampaign from "../components/ad-campaign/ad-campaign";
  import AppSdAdGroup from "../components/ad-group/ad-group";
  import AppSdAdProduct from "../components/ad-product/ad-product";
  import AppSdAdNegTarget from "../components/ad-neg-target/ad-neg-target";
  import AppSdAdProductTarget from "../components/ad-product-target/ad-product-target";
  import {inMarketMixin, tabResizeMixin} from "../../common/mixin";
  
  export default {
    name: "app-sd-ad-manager",
    components: {
      AppSdAdProductTarget,
      AppSdAdNegTarget, AppSdAdGroup,
      AppSdAdCampaign, AppSdAdProduct},
    mixins: [inMarketMixin, tabResizeMixin],
    props: {
      activeTab: {
        default: 'adCampaign',
      }
    },
    data() {
      return {
        activeTabMap: this.activeTab,
        timeStamp:null
      }
    },
    watch:{
      $route:{
        handler(){
          if(this.$route.query.timeStamp!=this.timeStamp){
            this.activeTabMap = this.$route.query.activeTabMap;
            this.timeStamp = this.$route.query.timeStamp;
          }
        },
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../common/common.scss';
  // /deep/.fixed-left--wrapper.vxe-table--body-wrapper  {
  //   overflow-x: hidden !important;
  // }
  .vxe-table--render-default:not(.is--empty).is--footer.is--scroll-x .vxe-table--body-wrapper{
    overflow-x: hidden;
  }
  .ad-tabs{
    height: 100%;
    display: flex;
    flex-direction: column;
    /deep/ .el-tabs__content{
      flex: 1;
    }
    /deep/ .el-tab-pane{
      height: 100%;
    }
  }
</style>
